import React, { FunctionComponent } from 'react';
import { ContactForm } from '../../ContactForm';
import './styles.scss';

type ContactComponentProps = {
  data: {
    title?: string | null;
    description?: string | null;
    cta?: string | null;
  }
}

const ContactComponent: FunctionComponent<ContactComponentProps> = ({ data }) => {
  return (
    <section className='contact-component'>
      <div className='wrapper'>
        <div className='contact-component-container'>
          <div className='contact-component-header'>
            <h2>{data.title ? data.title : 'Contact us'}</h2>
            {data.description && (
              <p>{data.description}</p>
            )}
          </div>
          <ContactForm cta={data.cta} />
        </div>
      </div>
    </section>
  );
}

export default ContactComponent;
